// Binds the mutually-nesting domain drawers into the NestedDrawer registry.
// Imported once at the app entry (main.tsx) so every name is bound before the
// first render; keeping these imports OUT of the drawer shells is what keeps
// the drawer module graph acyclic.
import { registerNestedDrawer } from './shared/NestedDrawer';
import BookingDrawer from './BookingDrawer';
import CarEditDrawer from './CarEditDrawer';
import CategoryEditDrawer from './CategoryEditDrawer';
import ClaimDrawer from './ClaimDrawer';
import CareDrawer from './CareDrawer';
import TripDrawer from './TripDrawer';
import ReceiptDrawer from './ReceiptDrawer';
import FuelTransactionDrawer from './FuelTransactionDrawer';
import UsersDrawer from './UsersDrawer';

registerNestedDrawer('booking', BookingDrawer);
registerNestedDrawer('carEdit', CarEditDrawer);
registerNestedDrawer('categoryEdit', CategoryEditDrawer);
registerNestedDrawer('claim', ClaimDrawer);
registerNestedDrawer('care', CareDrawer);
registerNestedDrawer('trip', TripDrawer);
registerNestedDrawer('receipt', ReceiptDrawer);
registerNestedDrawer('fuelTransaction', FuelTransactionDrawer);
registerNestedDrawer('users', UsersDrawer);
